module.exports = "//cdn.mxpnl.com/static/asset-cache/83e779abdf6b29f8eeaec3e466f5ab06/iron/common/assets/images/query/segmentation.svg";